export default String.raw`
.infographicBanner {
    padding: 0 5%;

    &__swiper {
        padding-bottom: 55px !important;

        .swiper-button-pause {
            bottom: 10px;
        }
    }

    &__slide {
        width: calc(100% / 1.5);
        &-container {
            flex-direction: row;
            align-items: start;
            column-gap:  16px;

            &-text {
                h3 {
                    margin-bottom: 8px;
                }

                h3, p {
                    text-align: left;
                }
            }
        }
    }

    &__prev, &__next {
        visibility: hidden;
    }
}
`